import * as Actions from '../../actions/searchresults';

const initialState={
    data: [],
    isLoading: false,
    isLoaded: false,
    error: false
};

const searchresults=function(state=initialState,action) {
    switch(action.type) {
        case Actions.SEARCH_VENUES_WITH_PRODUCTS: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: false
            };
        }
        case Actions.SEARCH_VENUES_WITH_PRODUCTS_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                isLoaded: true,
                error: false
            }
        }
        case Actions.SEARCH_VENUES_WITH_PRODUCTS_ERROR:{
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.error
            };
        }
        case Actions.CLEAR_SEARCH_RESULTS: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: false
            };
        }
        case Actions.CLEAR_SEARCH_RESULTS_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                isLoaded: false,
                error: false
            }
        }
        case Actions.CLEAR_SEARCH_RESULTS_ERROR:{
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.error
            };
        }


        default: {
            return state;
        }
    }
};

export default searchresults